import { RmaErrors } from '../../types/RmaErrors';
import { RESET_STATE, RmaErrorManagementActionTypes, SET_IS_RMA_ERRORS_LOADING, SET_RMA_TABLE_DATA } from './types';

export const setRmaTableData = (
  rmaErrors: RmaErrors[],
  total: number,
  nextPageUrl?: string,
): RmaErrorManagementActionTypes => ({
  type: SET_RMA_TABLE_DATA,
  payload: { rmaErrors, total, nextPageUrl },
});

export const setIsRmaErrorsLoading = (isRmaErrorsLoading: boolean): RmaErrorManagementActionTypes => ({
  type: SET_IS_RMA_ERRORS_LOADING,
  payload: { isRmaErrorsLoading },
});

export const resetState = (): RmaErrorManagementActionTypes => ({
  type: RESET_STATE,
});
